import { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Grid } from '@material-ui/core';
import { SELECTION_MODES } from './constants';
import styles from './styles';

const OptionSelector = ({
  classes,
  onChange,
  title = 'SELECTION',
  options = [],
  initialSelection = [],
  selectionMode = SELECTION_MODES.MULTIPLE,
  customClass = ''
}) => {
  const [selectedOptions, setSelectedOptions] = useState(initialSelection);

  useEffect(() => {
    if (initialSelection?.length) {
      onChange(selectedOptions);
    }
  }, []);

  const handleOptionClick = (selectedOption) => {
    let updatedSelection;
    if (selectionMode === SELECTION_MODES.SINGLE) {
      updatedSelection = [selectedOption];
    } else {
      updatedSelection = selectedOptions.includes(selectedOption)
        ? selectedOptions.filter((option) => option !== selectedOption)
        : [...selectedOptions, selectedOption];
    }
    setSelectedOptions(updatedSelection);
    onChange(updatedSelection);
  };

  const getOptionClass = (value, index) => {
    const classList = [classes.optionButton];
    selectedOptions.includes(value) && classList.push(classes.optionSelected);
    index < options.length - 1 && classList.push(classes.separator);
    customClass && classList.push(customClass);
    return classList.join(' ');
  };

  return (
    <Paper className={classes.container}>
      {title && <div className={classes.title}>{title}</div>}
      <Grid container spacing={1}>
        {options.map(({ label, value }, index) => (
          <Grid item key={label}>
            <div className={getOptionClass(value, index)} onClick={() => handleOptionClick(value)}>
              {label}
            </div>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default withStyles(styles)(OptionSelector);
